import { Schema as S } from "effect";

export const ListCalendarsRequestSchema = S.Struct({
  // required
  isPartnerCalendar: S.Boolean,

  // optional filters/sorting/pagination
  sort: S.optional(S.String),
  page: S.optional(S.Int),
  itemsPerPage: S.optional(S.Int),
  noCountLimit: S.optional(S.Union([S.Literal("true"), S.Literal("false")])),

  // date filters
  creationDate: S.optional(S.String),
  creationDate_lt: S.optional(S.String),
  creationDate_gt: S.optional(S.String),
});

export type ListCalendarsRequest = S.Schema.Type<typeof ListCalendarsRequestSchema>;
